"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "height",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "selfHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "parentHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "relayer",
                type: "address",
            },
        ],
        name: "BlockAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "height",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "selfHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "parentHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "relayer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmountTNT",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmountTDT",
                type: "uint256",
            },
        ],
        name: "BlockFinalized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldBaseQueries",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBaseQueries",
                type: "uint256",
            },
        ],
        name: "NewBaseQueries",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldEpochLength",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newEpochLength",
                type: "uint256",
            },
        ],
        name: "NewEpochLength",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldFinalizationParameter",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newFinalizationParameter",
                type: "uint256",
            },
        ],
        name: "NewFinalizationParameter",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "txId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "blockHeight",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "paidFee",
                type: "uint256",
            },
        ],
        name: "NewQuery",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldRelayerPercentageFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newRelayerPercentageFee",
                type: "uint256",
            },
        ],
        name: "NewRelayerPercentageFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldRewardAmountInTDT",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newRewardAmountInTDT",
                type: "uint256",
            },
        ],
        name: "NewRewardAmountInTDT",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldSubmissionGasUsed",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSubmissionGasUsed",
                type: "uint256",
            },
        ],
        name: "NewSubmissionGasUsed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldTeleportDAOToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newTeleportDAOToken",
                type: "address",
            },
        ],
        name: "NewTeleportDAOToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "TeleportDAOToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_anchor",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_headers",
                type: "bytes",
            },
        ],
        name: "addHeaders",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_oldPeriodStartHeader",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_oldPeriodEndHeader",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_headers",
                type: "bytes",
            },
        ],
        name: "addHeadersWithRetarget",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "availableTDT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "availableTNT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseQueries",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_txid",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_blockHeight",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_intermediateNodes",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
        ],
        name: "checkTxProof",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "currentEpochQueries",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "epochLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "finalizationParameter",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_hash",
                type: "bytes32",
            },
        ],
        name: "findHeight",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_height",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
        ],
        name: "getBlockHeaderFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_height",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
        ],
        name: "getBlockHeaderHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_height",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
        ],
        name: "getBlockHeaderHashContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_height",
                type: "uint256",
            },
        ],
        name: "getNumberOfSubmittedHeaders",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "initialHeight",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_genesisHeader",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "_height",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "_periodStart",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "_finalizationParameter",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_relayerPercentageFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_submissionGasUsed",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lastEpochQueries",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastSubmittedHeight",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_anchor",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_headers",
                type: "bytes",
            },
        ],
        name: "ownerAddHeaders",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_oldPeriodStartHeader",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_oldPeriodEndHeader",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_headers",
                type: "bytes",
            },
        ],
        name: "ownerAddHeadersWithRetarget",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pauseRelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "relayGenesisHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "relayerPercentageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardAmountInTDT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_baseQueries",
                type: "uint256",
            },
        ],
        name: "setBaseQueries",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_epochLength",
                type: "uint256",
            },
        ],
        name: "setEpochLength",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_finalizationParameter",
                type: "uint256",
            },
        ],
        name: "setFinalizationParameter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_relayerPercentageFee",
                type: "uint256",
            },
        ],
        name: "setRelayerPercentageFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_rewardAmountInTDT",
                type: "uint256",
            },
        ],
        name: "setRewardAmountInTDT",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_submissionGasUsed",
                type: "uint256",
            },
        ],
        name: "setSubmissionGasUsed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_TeleportDAOToken",
                type: "address",
            },
        ],
        name: "setTeleportDAOToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "submissionGasUsed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpauseRelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
//# sourceMappingURL=BitcoinRelay.js.map